import * as actionTypes from "../types";

const initialState = {
    divisibilityStatus: "",
    currentUser: {},
    profileExist: true,
    error: null,
    currentEmail: "",
    notifications: [], 
    notificationEmpty: false

}

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.USER_LOGIN: {
            return {
                ...state,
                currentEmail: action.payload.email,
                profileExist: action.payload.profileExist
            };
        }
        case actionTypes.CURRENT_USER: {
            return {
                ...state,
                currentEmail: action.payload.email,
                profileExist: action.payload.profileExist,
                currentUser: action.payload.currentUser
            };
        }
        case actionTypes.GOOGLE_LOGIN: {
            return {
                ...state,
                currentEmail: action.payload.email,
                profileExist: action.payload.profileExist
            };
        }
        case actionTypes.USER_LOGOUT: {
            return {
                ...state,
                currentEmail: action.payload.currentUser,
            };
        }
        case actionTypes.USER_ERROR: {
            return {
                ...state,
                error: action.payload
            };
        }
        case actionTypes.GET_NOTIFICATIONS: {
            return {
                ...state,
                notifications: action.payload.notifications,
                notificationEmpty: action.payload.notificationEmpty
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
}


